import "./App.css";
import RefreshButton from "./components/atoms/RefreshButton";
import Footer from "./components/molecules/Footer";
import Header from "./components/molecules/Header";
import Home from "./pages/Home";
import { Routes, Route } from "react-router-dom";
import PanelChart from "./pages/PanelChart";
import JodiChart from "./pages/JodiChart";
import DisclaimerModal from "./components/molecules/DisclaimerModal";

function App() {
  return (
    <div className="App bg-gray-50 min-h-[100vh]">
      <DisclaimerModal />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/panelChart/:gameId" element={<PanelChart />} />
        <Route path="/jodiChart/:gameId" element={<JodiChart />} />
      </Routes>
      <Footer />
      <RefreshButton />
    </div>
  );
}

export default App;
